const constants = {
    EVENTS: {
        SET: "set",
        RESET: "reset",
        UPDATE: "update"
    }
};
export { constants as FILTERER_CONSTANTS };
